/* eslint-disable no-undef */
/* eslint-disable no-console */
const getKeyFrameText = (cssRule) => {
  const tokens = ['@keyframes', cssRule.name, '{'];
  Array.from(cssRule.cssRules).forEach((cssRule) => {
    // type === CSSRule.KEYFRAME_RULE should always be true
    tokens.push(cssRule.keyText, '{', cssRule.style.cssText, '}');
  });
  tokens.push('}');
  return tokens.join(' ');
};

const fixUrlForRule = (cssRule) =>
  cssRule.cssText
    .split('url(')
    .map((line) => {
      if (line[1] === '/') {
        return `${line.slice(0, 1)}${window.location.origin}${line.slice(1)}`;
      }
      return line;
    })
    .join('url(');

const toWindowFeatures = (obj) =>
  Object.keys(obj)
    .reduce((features, name) => {
      const value = obj[name];
      if (typeof value === 'boolean') {
        features.push(`${name}=${value ? 'yes' : 'no'}`);
      } else {
        features.push(`${name}=${value}`);
      }
      return features;
    }, [])
    .join(',');

const copyStyles = (source, target) => {
  // Store style tags, avoid reflow in the loop
  const headFrag = target.createDocumentFragment();

  const styleSheets = Array.from(source.styleSheets).filter(
    (styleSheet) => !styleSheet.href || styleSheet.href.startsWith(window.location.origin)
  );
  styleSheets.forEach((styleSheet) => {
    // For <style> elements
    let rules;
    try {
      rules = styleSheet.cssRules;
    } catch (err) {
      console.error(err);
    }
    if (rules) {
      // IE11 is very slow for appendChild, so use plain string here
      const ruleText = [];

      // Write the text of each rule into the body of the style element
      Array.from(styleSheet.cssRules).forEach((cssRule) => {
        const { type } = cssRule;

        // Skip unknown rules
        if (type === CSSRule.UNKNOWN_RULE) {
          return;
        }

        let returnText = '';

        if (type === CSSRule.KEYFRAMES_RULE) {
          // IE11 will throw error when trying to access cssText property, so we
          // need to assemble them
          returnText = getKeyFrameText(cssRule);
        } else if ([CSSRule.IMPORT_RULE, CSSRule.FONT_FACE_RULE].includes(type)) {
          returnText = fixUrlForRule(cssRule);
        } else {
          returnText = cssRule.cssText;
        }
        ruleText.push(returnText);
      });

      const newStyleEl = target.createElement('style');
      newStyleEl.textContent = ruleText.join('\n');
      headFrag.appendChild(newStyleEl);
    } else if (styleSheet.href) {
      // for <link> elements loading CSS from a URL
      const newLinkEl = target.createElement('link');

      newLinkEl.rel = 'stylesheet';
      newLinkEl.href = styleSheet.href;
      headFrag.appendChild(newLinkEl);
    }
  });
  target.head.appendChild(headFrag);
};

export { copyStyles, toWindowFeatures };
